import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEyeemComponent } from './simple-icons-eyeem.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEyeemComponent ],
    exports:      [ SimpleIconsEyeemComponent ],
    bootstrap:    []
})
export class SimpleIconsEyeemModule {}
